module.exports = __webpack_public_path__ + "img/2.d741a2d2.jpg";